import * as React from "react";
import { func } from "../../../../../utils";

import "./index.css";
import useWindowSize from "../../../../../hooks/useWindowSize";

export interface CardTimelineProps {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
}

const CardTimeline: React.FC<CardTimelineProps> = ({ icon, title, subtitle }) => {
  const { size } = useWindowSize();
  // @ts-ignore
  const isMobileView = (size?.width || 0) <= 830;

  const wrapperClassName = isMobileView ? "rounded-[8px]" : "rounded-[8px] w-[228px] mx-auto";

  return (
    <div
      style={{
        border: "1px solid #DDE2E8",
        backgroundImage: `url(${func.getStaticImg("illustration/timeline-bg.png")})`,
      }}
      className={wrapperClassName}
    >
      <div className="flex items-center gap-x-[20px] py-[12px] px-[16px] card-timeline">
        {icon}
        <div className="flex flex-col justify-between">
          <h3 className="leading-0 text-[14px] text-white title-text">{title}</h3>
          <small className="subtitle-text leading-0 text-[12px] text-[#DDE2E8]">{subtitle}</small>
        </div>
      </div>
    </div>
  );
};

export default CardTimeline;
